// 업무 상태/우선순위 단일 소스 (eventTypes.js 패턴)

export const TASK_STATUS_LIST = [
  { value: 'pending', label: '대기', color: '#6b7280' },
  { value: 'in_progress', label: '진행중', color: '#2563eb' },
  // 앰버를 쓴다. reportUtils 가 이미 결재중을 warning(앰버)으로 매핑하고 있어서
  // "앰버 = 결재/승인 대기" 가 업무와 보고서 양쪽에서 같은 뜻이 된다.
  // 결재함에서 두 종류가 한 목록에 섞이므로 도메인 간 일관성이 도메인 내
  // 유일성보다 낫다.
  //
  // selectable:false 는 장식이 아니다 — 이 상태는 완료 요청 API 로만 진입해야 한다.
  // StatusPill 드롭다운과 MoveStatusSheet 가 이 플래그로 목록에서 걸러낸다.
  { value: 'pending_approval', label: '승인대기', color: '#d97706', selectable: false },
  { value: 'done', label: '완료', color: '#16a34a' }
]

/**
 * 칸반 컬럼은 3개로 유지한다.
 * TASK_STATUS_LIST 를 그대로 컬럼 목록으로 쓰면 4열이 되는데, 390px 화면에서
 * 컬럼당 90px 이라 카드가 읽히지 않는다. 게다가 승인대기는 작업 상태가 아니라
 * 대기 상태라서 진행중 컬럼 안에 두는 편이 의미상으로도 맞다.
 */
export const BOARD_COLUMNS = ['pending', 'in_progress', 'done']

export const STATUS_TO_COLUMN = {
  pending: 'pending',
  in_progress: 'in_progress',
  pending_approval: 'in_progress',
  done: 'done'
}

/** 사용자가 직접 고를 수 있는 상태 (승인대기 제외) */
export const SELECTABLE_STATUSES = TASK_STATUS_LIST.filter((s) => s.selectable !== false)

export const TASK_PRIORITY_LIST = [
  { value: 'high', label: '매우중요', color: '#dc2626' },
  { value: 'medium', label: '중요', color: '#d97706' },
  { value: 'low', label: '일반', color: '#16a34a' }
]

const statusMap = Object.fromEntries(TASK_STATUS_LIST.map((s) => [s.value, s]))
const priorityMap = Object.fromEntries(TASK_PRIORITY_LIST.map((p) => [p.value, p]))

export function getStatusLabel(v) { return (statusMap[v] || statusMap.pending).label }

export function getPriorityLabel(v) { return (priorityMap[v] || priorityMap.medium).label }
export function getPriorityColor(v) { return (priorityMap[v] || priorityMap.medium).color }

// 칸반 컬럼/레인 내부 카드 정렬 옵션
export const TASK_SORT_OPTIONS = [
  { value: 'due', label: '마감일순' },
  { value: 'priority', label: '중요도순' },
  { value: 'created', label: '등록일순' }
]

const PRIORITY_ORDER = { high: 0, medium: 1, low: 2 }

function cmpDue(a, b) {
  const ad = a.dueDate || ''
  const bd = b.dueDate || ''
  if (!!ad !== !!bd) return ad ? -1 : 1 // 마감일 있는 카드 먼저
  if (ad && bd && ad !== bd) return ad < bd ? -1 : 1
  return 0
}
function cmpPriority(a, b) {
  return (PRIORITY_ORDER[a.priority] ?? 9) - (PRIORITY_ORDER[b.priority] ?? 9)
}
function cmpCreated(a, b) {
  const ac = a.createdAt || ''
  const bc = b.createdAt || ''
  if (ac === bc) return 0
  return ac < bc ? 1 : -1 // 최신순(desc)
}
function cmpTitle(a, b) { return (a.title || '').localeCompare(b.title || '') }

/**
 * 컬럼/레인 내부 카드 정렬. 상태는 컬럼으로 분리되므로 상태는 정렬 키에서 제외한다.
 * @param {Array} list
 * @param {'due'|'priority'|'created'} sortBy
 */
export function sortTasks(list, sortBy = 'due') {
  const cmp = (a, b) => {
    let r
    if (sortBy === 'priority') r = cmpPriority(a, b) || cmpDue(a, b)
    else if (sortBy === 'created') r = cmpCreated(a, b)
    else r = cmpDue(a, b) || cmpPriority(a, b)
    return r || cmpTitle(a, b)
  }
  return [...list].sort(cmp)
}
